export type ItemStatus = "overdue" | "due_soon" | "upcoming" | "ok";

export function getItemStatus(nextDueAt: string): ItemStatus {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = new Date(`${nextDueAt}T00:00:00`);
  const diffDays = Math.floor(
    (due.getTime() - today.getTime()) / (1000 * 60 * 60 * 24),
  );

  if (diffDays < 0) return "overdue";
  if (diffDays <= 3) return "due_soon";
  if (diffDays <= 7) return "upcoming";
  return "ok";
}

export function getDaysUntilDue(nextDueAt: string): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = new Date(`${nextDueAt}T00:00:00`);
  return Math.floor((due.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

const STATUS_PRIORITY: Record<ItemStatus, number> = {
  overdue: 0,
  due_soon: 1,
  upcoming: 2,
  ok: 3,
};

export function compareByStatus(a: string, b: string): number {
  const statusA = getItemStatus(a);
  const statusB = getItemStatus(b);
  return STATUS_PRIORITY[statusA] - STATUS_PRIORITY[statusB];
}

export function getProgressPercentage(
  nextDueAt: string,
  intervalDays: number,
): number {
  if (intervalDays <= 0) return 100;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = new Date(`${nextDueAt}T00:00:00`);
  const cycleStart = new Date(due.getTime() - intervalDays * 86400000);
  const elapsed = today.getTime() - cycleStart.getTime();
  const total = intervalDays * 86400000;
  return Math.min(100, Math.max(0, (elapsed / total) * 100));
}

export const statusConfig: Record<
  ItemStatus,
  {
    labelKey: string;
    color: string;
    bgColor: string;
    borderColor: string;
    barColor: string;
    barTrackColor: string;
  }
> = {
  overdue: {
    labelKey: "common:status.overdue",
    color: "text-red-600",
    bgColor: "bg-red-50",
    borderColor: "border-l-red-500",
    barColor: "bg-red-500",
    barTrackColor: "bg-red-100",
  },
  due_soon: {
    labelKey: "common:status.dueSoon",
    color: "text-amber-600",
    bgColor: "bg-amber-50",
    borderColor: "border-l-amber-500",
    barColor: "bg-amber-500",
    barTrackColor: "bg-amber-100",
  },
  upcoming: {
    labelKey: "common:status.upcoming",
    color: "text-yellow-600",
    bgColor: "bg-yellow-50",
    borderColor: "border-l-yellow-500",
    barColor: "bg-yellow-500",
    barTrackColor: "bg-yellow-100",
  },
  ok: {
    labelKey: "common:status.ok",
    color: "text-green-600",
    bgColor: "bg-green-50",
    borderColor: "border-l-green-500",
    barColor: "bg-green-500",
    barTrackColor: "bg-green-100",
  },
};
